import * as z from "zod";

export const analyticsPixelScriptSchema = z
  .object({
    src: z.string().describe("The pixel script's URL."),
    apiUrl: z.string().describe("The endpoint the pixel sends events to."),
  })
  .describe(
    "AnalyticsPixelScript: the pixel script URL and the endpoint it sends events to.",
  );
export type AnalyticsPixelScript = z.infer<typeof analyticsPixelScriptSchema>;

// Kept apart from the analytics contracts so the SDK parses it without bundling the agent tool schemas.
export const analyticsPixelStatusResponseSchema = z.object({
  /** Null where the environment has no pixel configured. */
  script: analyticsPixelScriptSchema.nullable(),
  /** The most recent visit (page view, click or page leave) the pasted pixel sent from a site outside Replo in the last 30 days. */
  latestVisit: z
    .object({
      host: z.string(),
      url: z.string(),
      at: z.iso.datetime().describe("ISO 8601, UTC."),
    })
    .nullable(),
  /** True when the visit lookup failed, so a null `latestVisit` is unknown rather than "no visit yet". */
  visitLookupFailed: z.boolean().default(false),
});
export type AnalyticsPixelStatusResponse = z.infer<
  typeof analyticsPixelStatusResponseSchema
>;
